import { types } from "../action-types";

const initialState={
    loading: false,
    payments:[],
    error:{},
  }

const getAllPaymentsReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.GET_ALL_PAYMENTS_REQUESTED:
        return{
          ...state,
          loading: true,
        }
      case types.GET_ALL_PAYMENTS_SUCCESS:
        return{
          ...state,
          loading: false,
          payments: action.payload,
          error: false,
        }
      case types.GET_ALL_PAYMENTS_FAILURE:
        return{
          ...state,
          loading: false,
          payments: [],
          error: true,
        }
      default:
        return state;
    }
  };

  export default getAllPaymentsReducer;